/**
 * Sticky scroll chapters — works without GSAP.
 */
(function () {
  'use strict';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function sectionProgress(el) {
    var rect = el.getBoundingClientRect();
    var total = el.offsetHeight - window.innerHeight;
    if (total <= 0) return 0;
    return clamp(-rect.top / total, 0, 1);
  }

  function initPackHero() {
    var root = $('[data-pack-hero]');
    if (!root) return;
    var shot = $('.pack-hero__shot', root);
    var copy = $('.pack-hero__copy', root);
    var hint = $('.pack-hero__hint', root);
    var ticking = false;

    function paint() {
      ticking = false;
      var p = sectionProgress(root);
      if (shot) shot.style.transform = 'scale(' + (1 + p * 0.22) + ')';
      if (copy) {
        copy.style.opacity = String(1 - p * 1.15);
        copy.style.transform = 'translateY(' + (p * -40) + 'px)';
      }
      if (hint) hint.style.opacity = String(1 - p * 3);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(paint);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    paint();
  }

  function initQuestScroll() {
    var root = $('[data-quest-scene]');
    if (!root) return;

    var steps = $all('[data-standard-step]', root);
    var bgs = $all('[data-quest-bg]', root);
    var askEl = $('[data-quest-ask]', root);
    if (!steps.length) return;

    var last = -1;
    var timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = false;

    function syncVisual(index) {
      var step = steps[index];
      if (!step) return;
      if (askEl) {
        var q = step.querySelector('.standard__step-q');
        askEl.textContent = q ? q.textContent : '';
      }
      bgs.forEach(function (bg, i) {
        bg.classList.toggle('is-active', i === index);
      });
    }

    function go(index) {
      index = clamp(index, 0, steps.length - 1);
      last = index;
      syncVisual(index);
      root.dispatchEvent(new CustomEvent('quest:set', { detail: index }));
    }

    function stopAuto() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAuto() {
      if (timer || reduce || !visible) return;
      timer = window.setInterval(function () {
        go((last + 1) % steps.length);
      }, 5000);
    }

    function jumpTo(index) {
      go(index);
      stopAuto();
      startAuto();
    }

    steps.forEach(function (step, i) {
      step.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        jumpTo(i);
      });
      step.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % steps.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + steps.length) % steps.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = steps.length - 1;
        if (next === null) return;
        e.preventDefault();
        jumpTo(next);
        steps[next].focus();
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          visible = entry.isIntersecting;
          if (visible) startAuto();
          else stopAuto();
        });
      }, { threshold: 0.35 }).observe(root);
    } else {
      visible = true;
      startAuto();
    }

    go(0);
  }

  function init() {
    document.documentElement.classList.add('has-cine-motion');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      initPackHero();
    }
    initQuestScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
